export default __webpack_public_path__ + "static/media/lit.89fdcd86.png";